import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { ClienteUnicoAppDto, ClienteUnicoServiceProxy } from '../services/service-proxy/service-proxies';
import { AppService } from '../services/app.service';
import { Beneficio, beneficiosDePais } from '../shared/beneficios';
import { UmbralNivel, mismoNivel, umbralesDePais } from '../shared/niveles';

/** Un nivel tal como se muestra en la pantalla. */
interface NivelVista {
  nombre : string;
  rango : string;        // "De 2.600 a 3.999 puntos"
  beneficios : Beneficio[];
  actual : boolean;      // es el nivel del cliente
}

@Component({
  selector: 'app-mis-beneficios',
  templateUrl: './mis-beneficios.component.html',
  styleUrls: ['./mis-beneficios.component.scss']
})
export class MisBeneficiosComponent {

  isLoading = false;
  model? : ClienteUnicoAppDto | null;

  niveles : NivelVista[] = [];
  nivelActual = '';
  esGeneral = false;

  constructor(private clienteUnicoService : ClienteUnicoServiceProxy,
              public appService : AppService) {}

  ngOnInit() {

    const idUnico = this.appService.idUnico!;

    this.model = this.appService.getClienteAppData(idUnico);
    if (this.model) { this.armar(); return; }

    this.isLoading = true;
    this.clienteUnicoService
        .getForApp(idUnico, null)
        .pipe(finalize(() => this.isLoading = false))
        .subscribe(respuesta => {
          this.model = respuesta;
          this.appService.saveClienteAppData(this.model);
          this.armar();
        });
  }

  private get pais() : string {
    return (this.appService.countryCode
            ?? this.model?.fidelidadPointsTotal?.idPais
            ?? 'AR').toUpperCase();
  }

  private armar() {

    this.nivelActual = this.model?.fidelidadPointsTotal?.nombreTier ?? '';
    // General es el nivel base: no figura en la lista de beneficios.
    this.esGeneral = !this.nivelActual || mismoNivel(this.nivelActual, 'General');

    // Los umbrales son distintos en AR y CO.
    const escalera = umbralesDePais(this.pais);

    this.niveles = beneficiosDePais(this.pais).map(nivel => ({
      nombre : nivel.nombre,
      beneficios : nivel.beneficios,
      actual : mismoNivel(nivel.nombre, this.nivelActual),
      rango : this.rangoDe(nivel.nombre, escalera)
    }));
  }

  /** "De 2.600 a 3.999 puntos" — o "Desde 6.500 puntos" para el último. */
  private rangoDe(nombre : string, escalera : UmbralNivel[]) : string {

    const i = escalera.findIndex(t => mismoNivel(t.nombre, nombre));
    if (i < 0) return '';

    const desde = escalera[i].desde;
    const siguiente = escalera[i + 1];

    if (!siguiente) return `Desde ${this.miles(desde)} puntos`;

    return `De ${this.miles(desde)} a ${this.miles(siguiente.desde - 1)} puntos`;
  }

  private miles(n : number) : string {
    return n.toLocaleString('es-AR');
  }
}
